export default __webpack_public_path__ + "static/media/ipad.b9ceea5f.png";